import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@repo/blacksmith-ui/button";
import { cn } from "@repo/blacksmith-ui/cn";
import { STATUS_COLORS } from "@/components/filters/StatusFilter";
export const KEEP_GOING_ROUNDS = 3;
interface LoopLimitStripProps {
  headline: string;
  detail?: string;
  onKeepGoing?: (event: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  actionLabel?: string;
  pending: boolean;
  continued: boolean;
  continuedHeadline: string;
  continuedDetail?: string;
  testId: string;
  tabIndex?: number;
  className?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}
export function LoopLimitStrip(t0) {
  const $ = _c(26);
  const {
    headline,
    detail,
    onKeepGoing,
    actionLabel: t1,
    pending,
    continued,
    continuedHeadline,
    continuedDetail,
    testId,
    tabIndex,
    className,
    onClick
  } = t0;
  const actionLabel = t1 === undefined ? "Keep going" : t1;
  const displayedHeadline = continued ? continuedHeadline : headline;
  const displayedDetail = continued ? continuedDetail : detail;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex flex-wrap items-center justify-between gap-x-3 gap-y-1.5 rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-2", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = continued ? "var(--color-border)" : STATUS_COLORS.queued;
  let t4;
  if ($[2] !== t3) {
    t4 = <span aria-hidden={true} className="mt-[7px] size-1.5 shrink-0 rounded-full" style={{
      backgroundColor: t3
    }} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== displayedHeadline) {
    t5 = <p className="type-body-s-medium text-neutral-900 dark:text-neutral-100">{displayedHeadline}</p>;
    $[4] = displayedHeadline;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== displayedDetail) {
    t6 = displayedDetail ? <p className="type-body-xs-regular text-neutral-500 dark:text-neutral-400">{displayedDetail}</p> : null;
    $[6] = displayedDetail;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <div className="min-w-0">{t5}{t6}</div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <div className="flex min-w-0 items-start gap-2">{t4}{t7}</div>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== actionLabel || $[15] !== continued || $[16] !== onKeepGoing || $[17] !== pending || $[18] !== tabIndex) {
    t9 = !continued && onKeepGoing ? <Button type="button" disabled={pending} onClick={onKeepGoing} tabIndex={tabIndex} variant="secondary">{pending ? <Loader2 className="mr-1 size-3 animate-spin" /> : null}{actionLabel}</Button> : null;
    $[14] = actionLabel;
    $[15] = continued;
    $[16] = onKeepGoing;
    $[17] = pending;
    $[18] = tabIndex;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onClick || $[21] !== t2 || $[22] !== t8 || $[23] !== t9 || $[24] !== testId) {
    t10 = <div className={t2} data-testid={testId} onClick={onClick}>{t8}{t9}</div>;
    $[20] = onClick;
    $[21] = t2;
    $[22] = t8;
    $[23] = t9;
    $[24] = testId;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}